import React from "react";

export function AccountCard({ children, className = "" }) {
  return (
    <section className={["rounded-2xl border border-ink/8 bg-white p-5 md:p-6", className].join(" ")}>
      {children}
    </section>
  );
}

export function AccountStatus({ children, tone = "info" }) {
  return (
    <p
      role={tone === "error" ? "alert" : "status"}
      className={["text-sm leading-relaxed", tone === "error" ? "text-red-600" : "text-muted"].join(" ")}
    >
      {children}
    </p>
  );
}

export function AccountButton({ children, onClick, disabled, variant = "primary", type = "button", className = "" }) {
  const styles =
    variant === "primary"
      ? "bg-ink text-white disabled:opacity-50"
      : variant === "danger"
        ? "bg-red-700 text-white disabled:opacity-50"
        : "text-ink/80 ring-1 ring-ink/10 hover:bg-bg1 disabled:opacity-50";
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={["inline-flex min-h-11 items-center justify-center rounded-xl px-4 text-sm font-semibold", styles, className].join(
        " "
      )}
    >
      {children}
    </button>
  );
}

export function ToggleRow({ id, label, hint, checked, onChange, disabled }) {
  return (
    <label htmlFor={id} className="flex min-h-11 cursor-pointer items-start justify-between gap-4 py-2">
      <span>
        <span className="block text-sm font-medium text-ink">{label}</span>
        {hint ? <span className="mt-0.5 block text-xs text-muted">{hint}</span> : null}
      </span>
      <input
        id={id}
        type="checkbox"
        className="mt-1 h-5 w-5 rounded border-ink/20 text-ink focus:ring-hint/40"
        checked={Boolean(checked)}
        onChange={(event) => onChange(event.target.checked)}
        disabled={disabled}
      />
    </label>
  );
}
